import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Accordion from 'dashboard/components/Accordion';
import { ClassificationTestResult } from 'dashboard/components/DocumentTesterPanel/DocumentTesterPanel';
import Sticker from 'design-system/components/Sticker';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from 'design-system/components/Table';
import { Paragraph } from 'design-system/components/Text';

const StyledTable = styled(Table)`
  padding: ${Spacing[0]} ${Spacing[5]} ${Spacing[5]} ${Spacing[5]};
  table-layout: fixed;
`;

const StyledClassificationDocument = styled(Paragraph)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface TestResultsProps {
  classifications?: ClassificationTestResult[];
}

const TestResults = ({ classifications }: TestResultsProps) => {
  // TODO: move this to a separate component once BE is connected
  const ClassificationResults = () => (
    <Accordion
      title={
        <Paragraph size='lg' weight='bold' color='primary'>
          Classifications
        </Paragraph>
      }
      titleContainerHeight='60px'
      defaultExpanded={false}
      titleGapSize={Spacing[0]}
      showCaretOnHover={true}
    >
      <StyledTable>
        <TableHead>
          <TableRow>
            <TableHeaderCell size='sm' width='76px'>
              <Paragraph size='sm' color='primary'>
                Status
              </Paragraph>
            </TableHeaderCell>
            <TableHeaderCell size='sm'>
              <Paragraph size='sm' color='primary'>
                Document
              </Paragraph>
            </TableHeaderCell>
            <TableHeaderCell size='sm'>
              <Paragraph size='sm' color='primary'>
                Classification
              </Paragraph>
            </TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {classifications?.map((classification) => (
            <TableRow key={classification.document}>
              <TableCell size='sm'>
                <Sticker variant={classification.status === 'Accepted' ? 'green' : 'orange'}>
                  {classification.status}
                </Sticker>
              </TableCell>
              <TableCell size='sm'>
                <StyledClassificationDocument color='primary' size='sm'>
                  {classification.document}
                </StyledClassificationDocument>
              </TableCell>
              <TableCell size='sm'>
                <StyledClassificationDocument color='primary' size='sm'>
                  {classification.classification}
                </StyledClassificationDocument>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </Accordion>
  );

  return <ClassificationResults />;
};

export default TestResults;
